import FalconCardHeader from 'components/common/FalconCardHeader';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Spinner
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  setDeleteAccountInfo,
  updatePersistIdNumbersAction,
  updatePrivacyModeAction
} from 'stores/app';
import { setFeatures } from 'stores/authentication';
import api from 'util/api';
import userHelper from 'helpers/userHelper';

const AccountSettings = () => {
  const {
    updatingPrivacyMode,
    updatingPersistIdNumbers,
    userMaster,
    deleteUserInfo
  } = useSelector(state => state.app);
  const [isReactiveModel, setIsReactiveModel] = useState(false);

  const accountDeletedDate = useMemo(() => {
    const timezones = userHelper.getTimezoneObj(userMaster?.LocalTimezone);
    if (timezones?.zone && deleteUserInfo?.IsAccountDeleteRequested) {
      const parsedDate = moment.tz(deleteUserInfo?.AccountDeleteDate, 'UTC');
      return parsedDate.tz(timezones?.zone).format('MMM DD, YYYY');
    } else {
      return moment(timezones?.zone).format('MMM DD, YYYY');
    }
  }, [deleteUserInfo, userMaster]);

  const dispatch = useDispatch();

  const updatePrivacyMode = privacyMode => {
    let updatedUserMaster = Object.assign({}, userMaster);
    updatedUserMaster.PrivacyEnabled = privacyMode;
    dispatch(updatePrivacyModeAction(userMaster?.GUID, updatedUserMaster));
  };

  const updatePersistIdNumbersMode = persistIdNumbersMode => {
    let updatedUserMaster = Object.assign({}, userMaster);
    updatedUserMaster.PersistIdNumbers = persistIdNumbersMode;
    dispatch(updatePersistIdNumbersAction(userMaster?.GUID, updatedUserMaster));

    //dispatch(updatePersistIdNumbersAction(userMaster?.GUID, persistIdNumbersMode));
  };

  useEffect(() => {
    api.Token.detail('detail').then(res => {
      // Set feature flags into redux
      if (res?.User?.FeatureFlags) {
        dispatch(setFeatures(res.User.FeatureFlags || []));
      }
      if (res?.User?.IsAccountDeleteRequested) {
        dispatch(
          setDeleteAccountInfo({
            AccountDeleteDate: res.User.AccountDeleteDate,
            AccountDeleteRequestedOn: res.User.AccountDeleteRequestedOn,
            AccountDeleteType: res.User.AccountDeleteType,
            IsAccountDeleteRequested: res.User.IsAccountDeleteRequested
          })
        );
      } else {
        dispatch(setDeleteAccountInfo({}));
      }
    });
  }, []);
  const handleReactiveAccount = () => {
    setIsReactiveModel(!isReactiveModel);
  };
  const handleReactiveConfirm = () => {
    api.userRevertAccountdelete
      .update()
      .then(res => {
        // return res[0];
        setIsReactiveModel(!isReactiveModel);
        dispatch(setDeleteAccountInfo({}));
        toast.success('Your Account is reactivated successfully.', {
          theme: 'colored'
        });
      })
      .catch(error => {
        return null;
      });
  };
  return (
    <Card className="mb-3">
      <FalconCardHeader title="Account Settings" />
      <Card.Body className="bg-light">
        <div className="ps-2">
          <Row>
            <Col className="d-flex" lg={12}>
              <Form.Check
                type="switch"
                id="custom-switch-privacy-mode"
                label="Enable Privacy mode"
                className="form-label-nogutter"
                name="numberVisibility"
                onChange={() => updatePrivacyMode(!userMaster?.PrivacyEnabled)}
                checked={userMaster?.PrivacyEnabled}
              />{' '}
              {updatingPrivacyMode ? (
                <Spinner className="ms-2" size="sm" />
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </div>

        <div className="ps-2">
          <Row>
            <Col className="d-flex" lg={12}>
              <Form.Check
                type="switch"
                id="custom-switch-privacy-mode"
                label="Persist Id Number (Mobile App)"
                className="form-label-nogutter"
                name="numberVisibility"
                onChange={() =>
                  updatePersistIdNumbersMode(!userMaster?.PersistIdNumbers)
                }
                checked={userMaster?.PersistIdNumbers}
              />{' '}
              {updatingPersistIdNumbers ? (
                <Spinner className="ms-2" size="sm" />
              ) : (
                <></>
              )}
            </Col>
            {!userMaster?.PersistIdNumbers && (
              <Col className="d-flex" lg={12}>
                <Alert variant="info fs--1 p-2 mt-2">
                  When disabled, any ID scan will omit the serial number. This
                  feature is for use in the mobile app. Your setting choice here
                  will be reflected in the mobile app.
                </Alert>
              </Col>
            )}
            <Col className="" lg={12}>
              {!deleteUserInfo?.IsAccountDeleteRequested ? (
                <Button
                  as={Link}
                  variant="danger"
                  color="secondary"
                  size="sm"
                  className="mt-3 p-2 px-3 "
                  to={`/account/delete-account`}
                >
                  Delete My Account
                </Button>
              ) : (
                <>
                  <div>
                    <Alert variant="danger" className="fs--1 p-2 mb-1 mt-3">
                      Your account deletion request has been received. Your
                      account is scheduled to be permanently deleted on{' '}
                      {accountDeletedDate} and all associated data will be
                      removed.
                    </Alert>
                  </div>

                  <div>
                    <Button
                      as={Link}
                      variant="primary"
                      color="secondary"
                      size="sm"
                      className="mt-1 p-2 px-3"
                      onClick={handleReactiveAccount}
                      // to={`/account/delete-account`}
                    >
                      Stop Deletion & Reactivate Account
                    </Button>
                  </div>
                </>
              )}
            </Col>
          </Row>
        </div>
      </Card.Body>
      <Modal
        show={isReactiveModel}
        onHide={() => setIsReactiveModel(!isReactiveModel)}
        className="full-screen-modal"
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Reactivate Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to activate your account?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setIsReactiveModel(!isReactiveModel)}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={handleReactiveConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};

export default AccountSettings;
